import { useState } from "react";
import TextHighlighter from "@/admin/atoms/TextHighlighter";
import { getViewArea } from "src/pages/api/user";
// import { KnowledgeBaseProp } from "src/services/dataTypeDefinition.type";
import KnowledgeBaseTab from "../KnowledgeBaseTab";
import { BtnVariant } from "../KnowledgeBaseTab/KnowledgeBaseTab";
import styles from "./KnowledgeBaseEventManager.module.css";

// props: KnowledgeBaseProp
function KnowledgeBaseEventManager(): JSX.Element {
  //  const { searchTerm } = props;

  const searchTerm = "";

  const [btnList, setBntList] = useState<BtnVariant[]>([
    {
      title: "Create Event",
      bntActive: true,
    },
    {
      title: "View Event",
      bntActive: false,
    },
    {
      title: "Edit Event",
      bntActive: false,
    },
    {
      title: "View Event Analytics",
      bntActive: false,
    },
    {
      title: "View Registrants",
      bntActive: false,
    },
    {
      title: "Add Host",
      bntActive: false,
    },
    {
      title: "View Host",
      bntActive: false,
    },
    {
      title: "Edit Host",
      bntActive: false,
    },
    {
      title: "Delete Host",
      bntActive: false,
    },
  ]);

  const switchState = (index2: number) => {
    setBntList(
      btnList.map((btnObject, index) => {
        if (index === index2) {
          return {
            title: btnObject.title,
            bntActive: true,
          };
        }
        return {
          title: btnObject.title,
          bntActive: false,
        };
      })
    );
  };
  return (
    <div className={styles.frame}>
      <div className="font-bold text-[24px] text-[#262626]">EVENT MANAGER</div>
      <div className=" text-[#434343]">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="The event management feature helps plan and manage events to be held by
        tenants. It contains such functionalities as creating events, editing
        events, deleting events, viewing event analytics, and adding and editing
        hosts."
          id="courseManagerText1"
        />
      </div>

      <div>
        <KnowledgeBaseTab
          btnList={btnList}
          callBack={switchState}
          getViewArea={getViewArea}
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabCreateEvent"
      >
        Create Events
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/create-event.svg"
        alt="create event"
        className="mt-4"
      />
      <div className="text-[#434343] py-5 ">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='This is the default screen that appears if no event has been created. To
        create an event, click on
        <span style="font-weight: bold;">“Create Event”</span> in the
        <span style="font-weight: bold;">“All Events”</span> tab.'
          id="courseManagerText2"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/create-event2.svg"
        alt="create event"
        className="mt-4"
      />
      <div className="text-[#434343] py-5 ">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='After clicking the <span style="font-weight: bold;">“Create Event”</span> 
        button, you will be brought to the event details screen. Here you are to
        input the details of the event you are to create then click
        <span style="font-weight: bold;">“Save”</span>.'
          id="courseManagerText3"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/create-event3.svg"
        alt="create event"
        className="mt-4"
      />

      <div className="mt-10">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='In a case where you may be creating multiple events you can click the
        <span style="font-weight: bold;">“Save and Add Another”</span> button. This
        will save the event you are currently creating and remain on the event
        details page to create another event.'
          id="courseManagerText4"
        />
      </div>

      <div className="font-bold mt-4">PLEASE NOTE:</div>
      <TextHighlighter
        searchValue={searchTerm}
        textContent='<ul style="list-style-type: disc; padding-left: 40px;">
        <li>
          Tenants who are operating a Trial account can only have one open event created at a time. An upgrade to Premium will be required for full access. 
        </li>
        <li>
          An event cannot be created without a host. 
        </li>
        <li>
          Whenever a host who has been attached to an event is deleted while the event is still open, the event is automatically given a <span style="font-weight:bold;">“Default Host”</span> tag on the Admin view. In this case, the field for <span style="font-weight:bold;">“Host”</span> on the Candidates view will be vacant but, on the Admin, view it will read <span style="font-weight:bold;">“Default Host”</span>. This feature is built so that the field for the host is not left vacant on the Admin view. Admins can thereby assign a new host to the event afterwards
        </li>
        <li>
          To select a host on the event details screen, you will need to have initially added a host. All the added hosts will be listed in the dropdown that appears when you click the <span style="font-weight:bold;">“Hosts”</span> bar. Then you can make your selection (See <span style="font-weight:bold;">“Add host”</span> and <span style="font-weight:bold;">“View Host”</span> sections of the knowledge base for details)
        </li>
        <li>
          You can add a new host from this screen by clicking on the <span style="font-weight:bold;">“Add New Host”</span> button. Then input the host details and click <span style="font-weight:bold;">“Save”</span> (See <span style="font-weight:bold;">“Add host”</span> and <span style="font-weight:bold;">“View Host”</span> sections of the knowledge base for more details). 
        </li>
      </ul>'
        id="courseManagerText2745"
      />

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewEvent"
      >
        View Event
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/view-event.svg"
        alt="view event"
        className="mt-4"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='This is the default page that appears if no event has been created. To
        create a new event, click on the 
        <span style="font-weight: bold;">“Create Event” </span> button.'
          id="courseManagerText5"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/view-event2.svg"
        alt="view event"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='In an instance where events have been created, they appear here. To add
        a new event from this screen, click on the 
        <span style="font-weight: bold;">“Create New Event”</span> button at the top
        right-hand corner.'
          id="courseManagerText6"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabEditEvent"
      >
        Edit Event
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/edit-event.svg"
        alt="view event"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="To edit an event, click on the edit icon next to the event you wish to
        edit. You will be taken to the event details page."
          id="courseManagerText7"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/edit-event2.svg"
        alt="view event"
        className="mt-10"
      />

      <div className="mt-10">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='Here at the event details screen, you can edit whichever section of the
        event details you wish to edit. After making your edits, click 
        <span style="font-weight: bold;">“Save Changes”</span>'
          id="courseManagerText8"
        />
      </div>
      <div className="font-bold mt-4">PLEASE NOTE:</div>
      <div>
        <TextHighlighter
          searchValue={searchTerm}
          textContent="<ul style='list-style-type: disc; padding-left: 40px;'>
            <li>
              You can delete an event here by clicking on the delete icon at the
              bottom left-hand corner of the screen.
            </li>
            <li>
              You can also view event analytics and event registrants from the
              event details page.
            </li>
          </ul>"
          id="courseManagerText9"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewEventAnalytics"
      >
        View Event Analytics
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/event-analytic.svg"
        alt="analytic"
        className="mt-4"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='From the event details screen, click on 
        <span style="font-weight: bold;">“Event Analytics”</span> next to the 
        <span style="font-weight: bold;">“Event Details”</span> tab at the top of the
        screen.'
          id="courseManagerText10"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/event-analytic2.svg"
        alt="view event analytic"
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent=' On the <span style="font-weight: bold;">“Event Analytics”</span> screen, you
        will be able view the analytics of the event selected. This includes
        Total Registrations, Total Clicks, and Total Saves'
          id="courseManagerText10"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewRegistrants"
      >
        View Registrants
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/event-registrant.svg"
        alt="view registrant"
        className="mt-4"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='From the <span style="font-weight: bold;">“Event Details”</span> screen click
        on <span style="font-weight: bold;">“Registrants”</span> next to the 
        <span style="font-weight: bold;">“Event Analytics”</span> tab at the top of
        the screen.'
          id="courseManagerText11"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/event-registrant2.svg"
        alt="view registrant"
        className="mt-10"
      />
      <div className="mt-10">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='On the <span style="font-weight: bold;">“Registrants”</span> screen, you can
        view all the registrants that have registered for the selected event as
        at the time of viewing. Registrants`&apos;` details will also be
        displayed here. This list will be updated as more registrants
        subsequently register for the event. You can search for a registrant
        using the <span style="font-weight: bold;">“Search”</span> feature by
        clicking on the Search bar at the top right-hand corner of your screen.'
          id="courseManagerText12"
        />
      </div>
      <div className="font-bold mt-4">PLEASE NOTE:</div>
      <div>
        <TextHighlighter
          searchValue={searchTerm}
          textContent="<ul style='list-style-type: disc; padding-left: 40px;'>
          <li>
            The registrant details can only be viewed and cannot be edited.
          </li>
          <li>
            Details that will be collected from registrants as they register
            include Email address, First name, Last name, Location, and Mobile
            number. It is optional for registrants to input their mobile
            numbers.
          </li>
        </ul>"
          id="courseManagerText13"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabAddHost"
      >
        Add Host
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/add-host.svg"
        alt="add host"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='This is the default page that appears when no host has been added. To
        add a host, click on the <span style="font-weight: bold;">“Add Host”</span> 
        button.'
          id="courseManagerText14"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/add-host2.svg"
        alt="add host"
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='After clicking the <span style="font-weight: bold;">“Add Host”</span> button,
        you will be taken to the Host details screen. Here you are to input the
        details of the host you are to add. Then click 
        <span style="font-weight: bold;">“Save”</span>'
          id="courseManagerText15"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/add-host3.svg"
        alt="add host"
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='In a case where you may be adding multiple hosts, you can click the 
        <span style="font-weight: bold;">“Save and Add Another”</span> button. This
        will save the host you are currently creating and remain on the host
        details page to create another host.'
          id="courseManagerText16"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewHost"
      >
        View Host
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/view-host.svg"
        alt="view host"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To view all hosts, click on the
        <span style="font-weight: bold;">“Hosts”</span> tab towards the left of your
        screen. All saved hosts will appear here. You can search for hosts on
        this screen by simply inputting the host&#39;s name in the search bar
        at the top of the screen. You can also add a new host from this screen
        by clicking on the <span style="font-weight: bold;">“Add New Host”</span>
        button at the top right-hand corner.'
          id="courseManagerText17"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabEditHost"
      >
        Edit Host
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/edit-host.svg"
        alt="edit host"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent=" To edit a host, on the View host screen, click on the edit icon next to
        the host you wish to edit."
          id="courseManagerText18"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/edit-host2.svg"
        alt="edit host"
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='Edit the host details and click 
        <span style="font-weight: bold;">“Save Changes”</span>. You can also delete a
        host from this screen by clicking on the 
        <span style="font-weight: bold;">“Delete”</span> button at the bottom
        left-hand corner of the screen.'
          id="courseManagerText19"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabDeleteHost"
      >
        Delete Host
      </div>
      <img
        src="/images/knowledgebase-images/svgs/event/delete-host.svg"
        alt="delete host"
        className="mt-4"
      />
      <div>
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To delete a host, click on the delete icon next to the host`&apos;`s
        name on the <span style="font-weight: bold;">“View Hosts”</span> screen.'
          id="courseManagerText20"
        />
      </div>
    </div>
  );
}

export default KnowledgeBaseEventManager;
